import { Paper, styled, PaperProps } from "@mui/material";
import React from "react";

export const SuggestionsExpansionLinkPaper = styled(Paper)<PaperProps>(({ theme }) => ({
  textAlign: "end",
  paddingTop: "10px",
  paddingBottom: "10px",
  paddingRight: "5px",
  width: "100%",
})) as React.ComponentType<PaperProps>;
